/* import __COLOCATED_TEMPLATE__ from './date.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import moment from 'moment-timezone';
import { action } from '@ember/object';

interface Args {
  value: string | null;
  onUpdateValue: (value: unknown) => unknown;
  isReadOnly?: boolean;
  onFinishEditing?: () => unknown;
  placeholder?: string;
}

interface Signature {
  Args: Args;
}

export default class AttributeEditorDate extends Component<Signature> {
  // Unknown why we're using appService here
  // eslint-disable-next-line @intercom/intercom/service-allow-list
  @service declare appService: AppService;

  get timezone() {
    return this.appService.app.timezone;
  }

  get selectedValue() {
    let { value } = this.args;
    if (value === '' || value === null) {
      return undefined;
    }

    return value;
  }

  get valueAsMoment() {
    if (this.selectedValue) {
      let valueAsMoment = moment(this.selectedValue);
      if (valueAsMoment.isValid()) {
        return valueAsMoment;
      }
    }
    return undefined;
  }

  _changeAtInTimezone() {
    if (this.valueAsMoment) {
      return moment(this.valueAsMoment);
    }
    return undefined;
  }

  get selectedDate() {
    return this._changeAtInTimezone();
  }

  @action
  changeDate(date: any) {
    let changeAtCopy = this._changeAtInTimezone() || moment();
    changeAtCopy.set({
      date: date.moment.date(),
      month: date.moment.month(),
      year: date.moment.year(),
    });
    this.updateAttribute(changeAtCopy.toDate());
  }

  @action
  clear() {
    this.args.onUpdateValue(null);
  }

  @action
  updateAttribute(date: Date) {
    this.args.onUpdateValue(date.toISOString());
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::ConversationDetailsSidebar::Attribute::Editor::Date': typeof AttributeEditorDate;
    'inbox2/conversation-details-sidebar/attribute/editor/date': typeof AttributeEditorDate;
  }
}
